import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import { useClasses } from "@xo-union/react-css-modules";
import { useUniqueID } from "@xo-union/react-unique-id";
import format from "date-fns/format";
import { IconButton } from "@xo-union/tk-component-icons";
import cx from "classnames";
import DatePicker from "../DatePicker/index.js";
import DropdownContainer from "../DropdownContainer/index.js";
import styles from "../../css/styles.css";
import useIsModalBreakpoint from "../../useIsModalBreakpoint.js";
const formatSelected = (selected, formatString, locale) => {
  if (!selected) return '';
  return format(selected, formatString, locale);
};
const DatePickerDropdown = _ref => {
  let {
    id,
    block = true,
    dateFormat = 'yyyy-MM-dd',
    date,
    onDateChange,
    selected,
    onSelect,
    value,
    onChange,
    renderInput,
    classes: classesProp,
    locale,
    ...rest
  } = _ref;
  const classes = useClasses(styles, classesProp);
  const [isOpen, setOpen] = React.useState(false);
  const isModal = useIsModalBreakpoint();
  const valueToUse =
  // eslint-disable-next-line no-nested-ternary
  typeof value === 'undefined' ? typeof selected === 'undefined' ? date : selected : value;
  const dateString = formatSelected(valueToUse, dateFormat, locale);
  const containerRef = React.useRef();
  const inputRef = React.useRef();
  const closeButtonRef = React.useRef();
  const close = React.useCallback(() => {
    setOpen(false);
  }, []);
  const open = React.useCallback(() => {
    setOpen(true);
  }, []);
  const toggle = React.useCallback(() => {
    setOpen(v => !v);
  }, []);
  const handleKey = React.useCallback(evt => {
    if (evt.code === 'Space' || evt.key === ' ') {
      toggle();
      evt.preventDefault();
    }
    if (evt.key === 'Escape') {
      close();
      evt.preventDefault();
    }
  }, [toggle, close]);
  const handleChange = React.useCallback(evt => {
    if (typeof onChange === 'function') onChange(evt);
    close();
  }, [onChange, close]);
  const handleContainerBlur = React.useCallback(evt => {
    const focusLeftContainer = !containerRef.current.contains(evt.relatedTarget);
    if (!isModal && evt.relatedTarget && focusLeftContainer) {
      close();
    }
  }, [isModal, close]);
  const datepickerId = useUniqueID(id);
  const dialogId = `${datepickerId}-dialog`;
  React.useEffect(() => {
    if (!isOpen && containerRef.current.contains(document.activeElement)) {
      inputRef.current.focus();
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes['parent-container'], {
      [classes['is-block']]: block,
      [classes['is-inline']]: !block
    })
  }, renderInput({
    ref: inputRef,
    readOnly: true,
    onClick: open,
    onKeyDown: handleKey,
    value: dateString,
    role: 'button',
    type: 'button',
    'aria-haspopup': 'dialog',
    'aria-expanded': isOpen,
    'aria-controls': `${datepickerId}-dialog`
  }), /*#__PURE__*/React.createElement(DropdownContainer, {
    id: dialogId,
    ref: containerRef,
    initialFocusRef: closeButtonRef,
    isOpen: isOpen,
    classes: classes,
    numberOfMonths: 1,
    onClose: close,
    onBlur: handleContainerBlur
  }, /*#__PURE__*/React.createElement("div", {
    className: classes['close-button-container']
  }, /*#__PURE__*/React.createElement(IconButton, {
    ref: closeButtonRef,
    "aria-label": "close",
    className: classes['close-button'],
    onClick: close,
    name: "close",
    size: "md"
  })), /*#__PURE__*/React.createElement(DatePicker, _extends({
    id: datepickerId,
    numberOfMonths: 1,
    classes: classes,
    date: date,
    value: value,
    selected: selected,
    onChange: handleChange,
    onDateChange: onDateChange,
    onSelect: onSelect
  }, rest))));
};
export default DatePickerDropdown;